import { RootState } from "../../store/store";

export const selectSettings = (state: RootState) => state.settings;

export const selectGeneralSettings = (state: RootState) =>
  state.settings.general;

export const selectProductAnalyzerSettings = (state: RootState) =>
  state.settings.productAnalyzer;

export const selectPanelOrder = (state: RootState) =>
  state.settings.productAnalyzer.panelOrder;

export const selectTags = (state: RootState) =>
  state.settings.productAnalyzer.tags;
